import { render, staticRenderFns } from "./SvgArrow.vue?vue&type=template&id=3a20c286&lang=pug&"
import script from "./SvgArrow.vue?vue&type=script&lang=ts&"
export * from "./SvgArrow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports